import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { getAllbarbers } from "../api/barberApi.jsx";
import { getDashboardData } from "../api/dashboardApi.jsx";
import { updateAppointmentStatus } from "../api/appointmentApi.jsx";
import { BookingStatus } from "../components/BookingStatus.jsx";

const useDashboard = () => {
  const [nextAppointments, setNextAppointments] = useState(null);
  const [pendingAppointments, setPendingAppointments] = useState(null);
  const [totalpendingAppointments, setTotalpendingAppointments] = useState(0);
  const [totalCancelledAppointments, setTotalCancelledAppointments] =
    useState(0);
  const [todayBookingsCount, setTodayBookingsCount] = useState(null);
  const [availableStaff, setAvailableStaff] = useState(null);
  const [barberList, setBarberList] = useState(null);
  const [totalCustomer, setTotalCustomer] = useState(null);
  const [nextHoliday, setNextHoliday] = useState(null);
  const [moveComingAppoitment, setMoveComingAppoitment] = useState(null);
  const [inProgressAppointments, setInProgressAppointments] = useState([]);
  const [comingAppointments, setComingAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const { user } = useAuth();
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  useEffect(() => {
    fetchDashboardData();

    const interval = setInterval(fetchDashboardData, 30000); // every 30s
    return () => clearInterval(interval);
  }, []);
  // Fetch all dashboard data
  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      // You can customize endpoints as per your backend structure
      const response = await getDashboardData(user.barberShop, date);
      const {
        stats,
        inProgressAppointments,
        comingAppointments,
        pendingAppointments,
        availabelBarbers,
      } = response;
      setTodayBookingsCount(stats.todaysAppointments);
      setTotalpendingAppointments(stats.pendingAppointmentsCount);
      setTotalCancelledAppointments(stats.cancelled);
      setAvailableStaff(stats.activeStaff);
      setTotalCustomer(stats.totalCustomers);

      setBarberList(availabelBarbers);
      setInProgressAppointments(inProgressAppointments);
      setComingAppointments(comingAppointments);
      setPendingAppointments(pendingAppointments);
    } catch (err) {
      setMessage(err);
      setShowMessage(true);
      console.error("Failed to fetch dashboard data:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getNextAppoitmnet();
  }, [comingAppointments, inProgressAppointments]);

  const getNextAppoitmnet = () => {
    const nextAppointments = [];

    if (barberList == null) return;

    barberList.forEach((barber) => {
      const barberId = barber.id;
      // Step 1: Check if barber has an in-progress appointment
      const inProgress = (inProgressAppointments || []).find(
        (a) => a.staff.id === barberId,
      );

      if (inProgress) {
        // Barber is busy → use the in-progress appointment
        nextAppointments.push(inProgress);
      } else {
        // Step 2: Barber is free → get earliest upcoming appointment for this barber
        const upcomingForBarber = comingAppointments.filter(
          (a) => a.staff.id === barberId,
        );
        if (upcomingForBarber.length > 0) {
          nextAppointments.push(upcomingForBarber[0]);
        }
      }
    });
    setNextAppointments(nextAppointments);
  };
  const onSelectMoveComingAppoitment = async (status) => {
    onChangeStatutTo(moveComingAppoitment, status);
  };
  const onChangeStatutTo = async (id, changedStatus) => {
    if (changedStatus == 0) {
      var startTime = null;
      var endtime = null;
    } else if (changedStatus == 2) {
      var startTime = new Date().toISOString().split("T")[1].split(".")[0];
      var endtime = null;
    } else if (changedStatus == 3) {
      var startTime = null;
      var endtime = new Date().toISOString().split("T")[1].split(".")[0];
    }
    try {
      var response = await updateAppointmentStatus(
        user.barberShop,
        id,
        changedStatus,
        startTime,
        endtime,
      );
      if (response.data.isSuccess) {
        fetchDashboardData();
      } else {
        setMessage({
          text: response?.data.errors?.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };
  return {
    todayBookingsCount,
    totalpendingAppointments,
    totalCancelledAppointments,
    availableStaff,
    totalCustomer,
    nextHoliday,
    inProgressAppointments,
    barberList,
    nextAppointments,
    comingAppointments,
    pendingAppointments,
    moveComingAppoitment,
    setMoveComingAppoitment,
    onSelectMoveComingAppoitment,
    onChangeStatutTo,
    loading,
    setShowMessage,
    message,
    showMessage,
  };
};
export default useDashboard;
